//current locales supported by the
export type Locale = {
  key: string;
  label: string;
};
export const currentLocales: Locale[] = [
  { key: "ar", label: "ArContent" },
  { key: "en", label: "EnContent" },
];
